import React, { useState } from "react";
import { useKeycloak } from "@react-keycloak/web";
import { companyAreasPT } from "../../../../../utils/companyAreas";
import CompanyService from "../../../../../services/Companies/CompanyService";

const newCompanyModalStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
  },
  modal: {
    backgroundColor: "#1e1e1e",
    color: "#fff",
    borderRadius: "8px",
    padding: "20px",
    width: "380px",
    boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
    display: "flex",
    flexDirection: "column",
    gap: "14px",
    position: "relative",
  },
  header: {
    fontSize: "18px",
    fontWeight: "bold",
    marginBottom: "10px",
  },
  closeBtn: {
    position: "absolute",
    top: "10px",
    right: "12px",
    background: "transparent",
    border: "none",
    color: "#ccc",
    fontSize: "18px",
    cursor: "pointer",
  },
  label: {
    fontSize: "14px",
    fontWeight: "500",
    marginBottom: "5px",
  },
  input: {
    padding: "10px",
    borderRadius: "6px",
    border: `1px solid #333`,
    backgroundColor: "#121212",
    color: "#fff",
    fontSize: "14px",
    outline: "none",
    width: "100%",
  },
  select: {
    padding: "10px",
    borderRadius: "6px",
    border: "1px solid #333",
    backgroundColor: "#121212",
    color: "#999",
    fontSize: "14px",
    outline: "none",
    width: "100%",
    appearance: "none",
  },
  footer: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "10px",
    gap: "10px",
  },
  cancelBtn: {
    backgroundColor: "transparent",
    border: "1px solid #333",
    color: "#ccc",
    padding: "8px 14px",
    borderRadius: "6px",
    cursor: "pointer",
  },
  saveBtn: {
    backgroundColor: "#8b5cf6",
    border: "none",
    color: "#fff",
    padding: "8px 14px",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "bold",
  },
  error: {
    color: '#FF637E',
  }
};

const NewCompanyModal = ({ isOpen, onClose, onCompanyCreated }) => {
    const [company, setCompany] = useState("");
    const [cnae, setCnae] = useState("");
    const [errors, setErrors] = useState({});
    const { keycloak } = useKeycloak();

    if (!isOpen) return null;
    
    const handleSubmit = async ({ company, cnae }) => {
        let errorsObj = {};
        if (!company) errorsObj.company = 'Preencha o nome da empresa';
        if (!cnae) errorsObj.cnae = 'Selecione um setor'
        
        if (Object.keys(errorsObj).length > 0) {
            setErrors(errorsObj)
            return false
        }

        try {
            await CompanyService.createCompany(company, cnae, keycloak.token);
            console.log('Empresa criada com sucesso');
            
            setCompany('');
            setCnae('');
            setErrors({});

            // Refresh the companies list
            if (onCompanyCreated) {
                onCompanyCreated();
            }

            onClose();
        } catch (error) {
            console.error('Erro ao criar empresa:', error);
            setErrors({ general: error.message || 'Erro ao criar empresa. Tente novamente.' });
        }
    }

    return (
        <div style={newCompanyModalStyles.overlay}>
            <div style={newCompanyModalStyles.modal}>
            <button style={newCompanyModalStyles.closeBtn} onClick={onClose}>
                ✕
            </button>

            <h2 style={newCompanyModalStyles.header}>Adicionar nova empresa</h2>
            {errors.company && ( <p style={newCompanyModalStyles.error}>{errors.company}</p>)}
            {errors.cnae && ( <p style={newCompanyModalStyles.error}>{errors.cnae}</p>)}
            {errors.general && ( <p style={newCompanyModalStyles.error}>{errors.general}</p>)}
            
            <div>
                <label style={newCompanyModalStyles.label}>Nome da Empresa*</label>
                <input
                    style={newCompanyModalStyles.input}
                    type="text"
                    placeholder="Digite o nome oficial da empresa"
                    value={company}
                    onChange={(e) => setCompany(e.target.value)}
                />
            </div>

            <div>
                <label style={newCompanyModalStyles.label}>Setor*</label>
                <select
                    style={newCompanyModalStyles.select}
                    value={cnae}
                    onChange={(e) => setCnae(e.target.value)}
                >
                <option value="">Selecione a área</option>
                    {companyAreasPT.map(item => (
                        <option value={item.area}>{item.area} - {item.cnae}</option>
                    ))}
                </select>
            </div>

            <div style={newCompanyModalStyles.footer}>
                <button style={newCompanyModalStyles.cancelBtn} onClick={onClose}>
                    Cancelar
                </button>

                <button
                    style={newCompanyModalStyles.saveBtn}
                    onClick={() => handleSubmit({ company, cnae })}
                >
                    salvar
                </button>
            </div>
            </div>
        </div>
    );
};

export default NewCompanyModal;